import React from 'react';
import { useLaunchStatus } from '../../hook/useLaunchStatus';

const LAUNCH_DATE = "2026-09-14T09:30:00"; // Set your launch date here

export default function CurtainRaiser() {
  const { timeLeft } = useLaunchStatus(LAUNCH_DATE);

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>Coming Soon!</h1>
      <p>We are launching our amazing new platform on September 14, 2026.</p>
      
      {/* Countdown Timer */}
      <div style={{ fontSize: '24px', margin: '20px 0', fontWeight: 'bold' }}>
        {timeLeft.days}d : {timeLeft.hours}h : {timeLeft.minutes}m : {timeLeft.seconds}s
      </div>

      {/* Feature Highlights */}
      <div style={{ marginTop: '40px' }}>
        <h3>Key Features to Expect:</h3>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <li>🚀 Blazing Fast Performance</li>
          <li>🎨 Sleek Modern UI/UX</li>
          <li>🔒 Enhanced Security Controls</li>
          <li>📸Virtual Try On</li>
          <li>🕶️Large variety of products</li>
        </ul>
      </div>
    </div>
  );
}
